/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { IoIosWarning } from 'react-icons/io';
import { toast } from 'react-toastify';

import moment from 'moment';
import { useTour } from 'hooks/useTour';

import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import OutlinedButton from 'components/layout/form/outlinedButton';
import api from 'services/api';
import Loading from 'components/layout/loading';
import GenericNavBar from 'newComponents/GenericNavBar';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import ModalContentBestTimes from './Modal';
import ModalContentConfirm from './ModalConfirm';

import {
  Container,
  ContainerLabels,
  Content,
  ContentHeader,
  ContentTitle,
  Divider,
  Header,
  Info,
  InfoText,
  Item,
  ItemDivider,
  Items,
  ItemTitle,
  Label,
  LabelContent,
  ModalStyled,
  NotFound,
  Subtitle,
  TableWrap,
  Title,
  Value,
} from './styles';

export interface IData {
  weekDay: string;
  intervals?: {
    beginTime: string;
    endTime: string;
  }[];
  sort?: number;
}

const weekDayPortugues = {
  SUNDAY: 'Domingo',
  MONDAY: 'Segunda-feira',
  TUESDAY: 'Terça-feira',
  WEDNESDAY: 'Quarta-feira',
  THURSDAY: 'Quinta-feira',
  FRIDAY: 'Sexta-feira',
  SATURDAY: 'Sábado',
};

const sortData = {
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURSDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7,
};

const BestTimes = (): JSX.Element => {
  const [data, setData] = useState<IData[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataProvisional, setDataProvisional] = useState<IData[]>([]);
  const [loadingSave, setLoadingSave] = useState(false);
  const [isDisabledButtonCreateEdit, setIsDisabledButtonCreateEdit] =
    useState(false);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('bestTimes');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  const requestWindows = async (): Promise<void> => {
    setLoading(true);
    try {
      const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
      const siteId = localStorage.getItem(
        '@UltragazEmpresarial:customerSiteId'
      );

      const headers = {
        'Content-Type': 'application/json',
        access_token: token as string,
      };

      const result = await api.get(
        `industrial/case/v1/refuels/windows/${siteId}`,
        {
          headers,
          method: 'GET',
        }
      );

      setData(
        result?.data?.windows?.map((item: any) => ({
          ...item,
          // @ts-ignore
          sort: sortData[item?.weekDay],
        }))
      );
      setDataProvisional(
        result?.data?.windows?.map((item: any) => ({
          ...item,
          // @ts-ignore
          sort: sortData[item?.weekDay],
        }))
      );

      if (result?.data?.updateDate) {
        const momentUpdateDate = moment(result?.data?.updateDate);
        const momentToday = moment();

        const diffMomentSeconds = momentToday.diff(momentUpdateDate, 'seconds');

        if (diffMomentSeconds <= 60 * 60 * 72) {
          setIsDisabledButtonCreateEdit(false);
        } else {
          setIsDisabledButtonCreateEdit(!result?.data?.showPopup);
        }
      } else {
        setIsDisabledButtonCreateEdit(!result?.data?.showPopup);
      }
    } catch (err: any) {
      const erro = err.response;
      setIsDisabledButtonCreateEdit(true);

      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      await requestWindows();
    })();
  }, []);

  const onClickSuccess = async (): Promise<void> => {
    setLoadingSave(true);

    try {
      const token = localStorage.getItem('@UltragazEmpresarial:accessToken');

      const headers = {
        'Content-Type': 'application/json',
        access_token: token as string,
      };

      await api.post(
        `industrial/case/v1/refuels/windows`,
        {
          siteId: localStorage.getItem('@UltragazEmpresarial:customerSiteId'),
          windows: dataProvisional?.filter(
            (item) => item?.intervals && item?.intervals?.length > 0
          ),
        },
        {
          headers,
          method: 'POST',
        }
      );

      setShowModal(false);
      setShowModalConfirm(false);
      setData(dataProvisional);
      await requestWindows();
    } catch (err: any) {
      const erro = err.response;

      if (erro) {
        const { message, code } = err.response.data;
        if (code) {
          setShowModal(true);
          setShowModalConfirm(false);
        }
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }

    setLoadingSave(false);
  };

  const onClickFail = (): void => {
    setShowModalConfirm(false);
    setShowModal(true);
  };

  return (
    <GenericNavBar
      breadcrump="› Melhores horários"
      selected="melhores-horarios"
      openSubMenu="abastecimento"
      intro={() => true}
    >
      {loading ? (
        <Loading />
      ) : (
        <Container>
          <Header>
            <Title>Melhores horários de abastecimento</Title>
            <Subtitle>
              Cadastre os intervalos de horário mais adequados para realizarmos
              o seu abastecimento.
            </Subtitle>
            <Divider />
            <Info>
              <IoIosWarning />
              <InfoText>
                Estamos trabalhando para conseguir realizar o seu abastecimento
                o mais próximo possível do intervalo de horário cadastrado,
                porém podem surgir imprevistos.
              </InfoText>
            </Info>
            <Info>
              <IoIosWarning />
              <InfoText>
                Após salvar os melhores horários para seu abastecimento, ajustes
                só poderão ser solicitados através da Central de Atendimento,
                nos números 4003-1616 (regiões metropolitanas) ou 0800-886-1616
                (demais regiões).
              </InfoText>
            </Info>
          </Header>
          <TableWrap
            showTour={showTour && tourType === 'bestTimes' && tourStep === 1}
          >
            <Content>
              <ContentHeader>
                <ContentTitle>Horários de abastecimento</ContentTitle>
                <OutlinedButton
                  onClick={() => setShowModal(true)}
                  disabled={isDisabledButtonCreateEdit}
                >
                  {!data?.length
                    ? 'Criar intervalo(s) de horário(s)'
                    : 'Editar intervalo(s) de horário(s)'}
                </OutlinedButton>
              </ContentHeader>
              <Divider />
              {!data?.length ? (
                <NotFound>
                  Não consta nenhum horário de abastecimento cadastrado
                </NotFound>
              ) : (
                <Items>
                  {data
                    // @ts-ignore
                    ?.sort((a, b) => a?.sort - b?.sort)
                    ?.map((item) => {
                      if (item?.intervals && item?.intervals?.length > 0) {
                        return (
                          <Item key={`list-item-best-times-${item?.weekDay}`}>
                            <ItemTitle>
                              {/* @ts-ignore */}
                              {weekDayPortugues[item?.weekDay]}
                            </ItemTitle>
                            <ItemDivider />
                            <ContainerLabels>
                              {item?.intervals?.map((item2, index) => {
                                return (
                                  <LabelContent
                                    key={`interval-${item?.weekDay}-${index}`}
                                  >
                                    <Label>{`Intervalo ${index + 1}`}</Label>
                                    <Value>{`${item2.beginTime} - ${item2.endTime}`}</Value>
                                  </LabelContent>
                                );
                              })}
                            </ContainerLabels>
                            {/* <LabelContent>
                          <Label>Última modificação</Label>
                          <Value>30/10/2022</Value>
                        </LabelContent> */}
                          </Item>
                        );
                      }

                      return null;
                    })}
                </Items>
              )}
            </Content>
            {showTour && tourType === 'bestTimes' && tourStep === 1 && (
              <TourBalloon
                title="Melhores horários de abastecimento"
                content="Aqui você cadastra os intervalos de horários mais adequados para realizarmos o seu abastecimento."
                position={{
                  left: '50%',
                  right: '0',
                  top: '-190px',
                  arrowPosition: 'bottom',
                  maxWidth: 'unset',
                  boxShadow: false,
                  width: '350px',
                  transform: 'translateX(-50%)',
                }}
              />
            )}
          </TableWrap>
        </Container>
      )}

      <ModalStyled
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered
      >
        <ModalContentBestTimes
          onClose={() => setShowModal(false)}
          data={data}
          setDataProvisional={setDataProvisional}
          dataProvisional={dataProvisional}
          openModalConfirm={() => setShowModalConfirm(true)}
        />
      </ModalStyled>

      <ModalStyled
        show={showModalConfirm}
        onHide={onClickFail}
        animation={false}
        centered
      >
        <ModalContentConfirm
          onClickSuccess={onClickSuccess}
          onClickFail={onClickFail}
          loading={loadingSave}
        />
      </ModalStyled>
    </GenericNavBar>
  );
};

export default BestTimes;
